import React from "react";

const SummaryMetricCard = ({ title, value, className = "", fontSize = "20px" }) => {
  return (
    <div
      className={`p-3 text-center rounded-3 ${className}`}
      style={{ backgroundColor: "#e0f2fe" }}
    >
      <div className="text-muted mb-1" style={{ fontSize: "13px" }}>
        {title}
      </div>
      <div className="fw-bold text-dark" style={{ fontSize }}>
        {value}
      </div>
    </div>
  );
};

export default SummaryMetricCard;
